export const HAS_CSA_SERVICE = process.env.REACT_APP_ENABLE_CSA === 'true';
export const HAS_AGENCY_SERVICE = process.env.REACT_APP_ENABLE_AGENCY === 'true';

const allowedVerificationMethods = () => {
  const verDefault = ['email', 'sms', 'tpv'];
  const allowed = process.env.REACT_APP_ALLOWED_VERIFICATION_METHODS
    ?.split(',')
    .filter(x => ['email', 'sms', 'tpv'].includes(x));

  return allowed?.length ? allowed : verDefault;
}

export const ALLOWED_VERIFICATION_METHODS = allowedVerificationMethods()